<template>

	<div class="report_container full" v-loading="loading">
		<vxe-grid :id="reportName+'_list'" class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
		</vxe-grid>
		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import exportTable from '@_system/components/export/index.vue'
	export default {
		mixins: [reportBase],
		name: 'report',
		props: {

		},
		data() {
			return {
				footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'num',
					toFixed: 1
				}, {
					type: 'field',
					field: 'preamount',
					toFixed: 4
				}, {
					type: 'field',
					field: 'amount',
					toFixed: 4
				}],
				showFooter: true,
				reportName: 'suppliercompany',
				windowName: '供应商公司',
				exportRef: Math.random(),
				loading: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			exportTable
		}
	}
</script>
